import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";
import { IEmsResponse } from "../services/ems/typings/IEmsResponse";

export class HomeScreenStore {
    selectedFiltyer: string = "desc";
    activeIncidentList = [];
    activityList = [];
    newIncidentList = [];
    activeIncidentFilterDropdown: boolean = false;
    activityFilterDropdown: boolean = false;
    showAssignSomeoneModal: boolean = false;
    searchEmsList: string = "";
    selectedEmsId: string = "";
    EmsList: IEmsResponse[] = [];
    emsSearchString: string = "";
    selectedMedicalIdList: string = "";
    assignToSomeoneModal: boolean = false;
    totalSlides: number | null = null;
    listedIncidentIds: number[] = [];
    toggleDesign: boolean = false;


    rootStore: IRootStore;
    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore
    }

    setActiveIncident = (activeIncidents: []) => {
        this.activeIncidentList = activeIncidents;
    }
    get getActiveIncidentList() {
        return this.activeIncidentList;
    }

    setActivity = (activities: any) => {
        this.activityList = [];
        this.activityList = activities;
    }
    get getActivityList() {
        return this.activityList;
    }

    setNewIncident = (newIncident: any) => {
        this.newIncidentList = newIncident;
    }
    get getNewIncidentList() {
        return this.newIncidentList;
    }

    setActiveIncidentFilter = () => {
        this.activeIncidentFilterDropdown = !this.activeIncidentFilterDropdown;
    }
    get getActiveIncidentFilter() {
        return this.activeIncidentFilterDropdown;
    }

    setActivityFilter = () => {
        this.activityFilterDropdown = !this.activityFilterDropdown;
    }
    get getActivityFilter() {
        return this.activityFilterDropdown;
    }

    handleAssignSomeoneModal = (value: boolean) => {
        this.showAssignSomeoneModal = value;
    }

    get getAssignSomeoneModal() {
        return this.showAssignSomeoneModal;
    }

    handleEmsListSearch = (searchString: string) => {
        this.searchEmsList = searchString;
    }
    get getEmsListSearch() {
        return this.searchEmsList;
    }

    handleSelectEmsId = (id: string) => {
        this.selectedEmsId = id;
    }
    get getSelectedEmsId() {
        return this.selectedEmsId;
    }

    get getEmsList() {
        return this.EmsList;
    }

    handleEmsSearchString = (val: string) => {
        this.emsSearchString = val;
    }

    get getemsSearchString() {
        return this.emsSearchString;
    }
    
    handleSelectedMedicalIdList = (id: string) => {
        this.selectedMedicalIdList = id;
    }

    resetSelectedMedicalIdList = () => {
        this.selectedMedicalIdList = "";
    }

    emptySelectedMedicalList = () => {
        this.selectedMedicalIdList = "";
    }

    get getSelectedMedicalList() {
        return this.selectedMedicalIdList;
    }

    handleAssignToSomeoneModal = (value: boolean) => {
        this.assignToSomeoneModal = value;
    }

    get getAssignToSomeoneModal() {
        return this.assignToSomeoneModal;
    }

    setSlide = (length: number) => {
        this.totalSlides = length;
    }
    getSlide() {
        return this.totalSlides;
    }

    setIncidentId = (id: number) => {
        if (!this.listedIncidentIds.includes(id)) {
            this.listedIncidentIds.push(id);
        }
    }
    get getIncidentList() {
        return this.listedIncidentIds.join(",");
    }
    resetIdsList = () => {
        this.listedIncidentIds = [];
    }

    setSelectedFilter = (type: string) => {
        this.selectedFiltyer = type;
    }
    get getSelectedFilter() {
        return this.selectedFiltyer;
    }

    handleToggleDesign = () => {
        this.toggleDesign = !this.toggleDesign;
    }
    get getToggleDesign() {
        return this.toggleDesign;
    }
}